<template>
  <div class="container page">
    <div class="header">
      <van-nav-bar :title="text.title" class="nav-bar">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <van-pull-refresh
        v-model="isLoading"
        :pulling-text="text.pull"
        :loosing-text="text.release"
        :loading-text="text.loading"
        @refresh="onRefresh"
      >
        <van-empty
          v-if="!loading && list.length === 0"
          :description="loadFailed ? text.failed : text.empty"
        />

        <div
          v-for="(v, key) in list"
          :key="v.id == null ? key : v.id"
          class="item_list"
        >
          <div class="topInfo">
            <span :style="Number(v.status) === 2 ? { color: '#07c160' } : {}">
              {{ statusLabel(v.status) }}
            </span>
            <span>{{ text.amount }} {{ recordMoney(v.money) }}</span>
          </div>

          <div class="desc">
            <span>{{ text.description }} {{ v.desc || '' }}</span>
          </div>

          <div class="time">
            <span>{{ text.submitted }} {{ v.create_time }}</span>
          </div>

          <div class="time">
            <span>{{ text.reviewed }} {{ reviewTime(v) }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
const TEXT = {
  'zh-CN': {
    title: '提现记录',
    amount: '金额：',
    description: '说明：',
    submitted: '提交时间：',
    reviewed: '审核时间：',
    pending: '待审核',
    approved: '审核通过',
    rejected: '审核拒绝',
    unknown: '未知状态',
    empty: '暂无提现记录',
    failed: '记录加载失败，请下拉重试',
    refreshed: '刷新成功',
    pull: '下拉即可刷新',
    release: '释放即可刷新',
    loading: '加载中…'
  },
  'ja-JP': {
    title: '出金履歴',
    amount: '金額：',
    description: '備考：',
    submitted: '申請日時：',
    reviewed: '審査日時：',
    pending: '審査待ち',
    approved: '承認済み',
    rejected: '却下',
    unknown: '不明な状態',
    empty: '出金履歴はありません',
    failed: '履歴を取得できませんでした。下に引いて再試行してください',
    refreshed: '更新しました',
    pull: '下に引いて更新',
    release: '指を離して更新',
    loading: '読み込み中…'
  },
  'en-US': {
    title: 'Withdrawal History',
    amount: 'Amount:',
    description: 'Remarks:',
    submitted: 'Submitted on:',
    reviewed: 'Review time:',
    pending: 'Pending review',
    approved: 'Approved',
    rejected: 'Rejected',
    unknown: 'Unknown status',
    empty: 'No withdrawal records',
    failed: 'Unable to load records. Pull down to retry.',
    refreshed: 'Refreshed successfully',
    pull: 'Pull down to refresh',
    release: 'Release to refresh',
    loading: 'Loading…'
  }
};

export default {
  data() {
    return {
      isLoading: false,
      loading: false,
      loadFailed: false,
      list: []
    };
  },
  computed: {
    text() {
      return TEXT[this.$i18n.locale] || TEXT['zh-CN'];
    }
  },
  methods: {
    back() {
      this.$router.back();
    },
    statusLabel(status) {
      const labels = {
        1: this.text.pending,
        2: this.text.approved,
        3: this.text.rejected
      };
      return labels[Number(status)] || this.text.unknown;
    },
    reviewTime(record) {
      if (Number(record.status) === 1) return this.text.pending;
      const value = record.update_time;
      if (!value || value === '待审核') return '--';
      return value;
    },
    recordMoney(value) {
      if (
        value == null ||
        String(value).trim() === '' ||
        !Number.isFinite(Number(value))
      ) {
        return '--';
      }

      const quote = this.$withdrawQuote();
      if (!quote) return '--';

      return '-' + this.$displayMoney(Math.abs(Number(value)));
    },
    async onRefresh() {
      const success = await this.getUserWithdrawList();
      if (success) this.$toast(this.text.refreshed);
    },
    async getUserWithdrawList() {
      if (this.loading) {
        this.isLoading = false;
        return false;
      }

      this.loading = true;
      this.loadFailed = false;

      try {
        const res = await this.$http({
          method: 'get',
          url: 'user_get_withdraw_list'
        });

        if (!res || Number(res.code) !== 200 || !Array.isArray(res.data)) {
          throw new Error('WITHDRAW_RECORD_LOAD_FAILED');
        }

        this.list = res.data;
        return true;
      } catch (error) {
        this.loadFailed = true;
        this.$toast(this.text.failed);
        return false;
      } finally {
        this.loading = false;
        this.isLoading = false;
      }
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.replace({ path: '/Login' });
      return;
    }
    this.getUserWithdrawList();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 35px;
  font-weight: 700;
  color: #ff253f;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{
  float: right;
}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}

</style>
